import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import './Testimonials.css';
import { testimonials } from '../mockData';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const current = testimonials[currentIndex];

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-2">What Our Customers Say</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', marginTop: '1rem' }}>
            Join thousands of happy customers loving fresh microgreens
          </p>
        </div>
        <div className="testimonial-container">
          <button className="testimonial-nav prev" onClick={prevTestimonial} aria-label="Previous testimonial">
            <ChevronLeft size={24} />
          </button>
          
          <div className="testimonial-card">
            <div className="testimonial-rating">
              {[...Array(current.rating)].map((_, i) => (
                <Star key={`star-${i}`} size={20} fill="var(--accent-primary)" stroke="var(--accent-primary)" />
              ))}
            </div>
            <p className="testimonial-text">"{current.text}"</p>
            <div className="testimonial-author">
              <img src={current.image} alt={current.name} className="author-image" />
              <div className="author-info">
                <div className="author-name">{current.name}</div>
                <div className="author-location">{current.location}</div>
              </div>
            </div>
          </div>
          
          <button className="testimonial-nav next" onClick={nextTestimonial} aria-label="Next testimonial">
            <ChevronRight size={24} />
          </button>
        </div>
        
        <div className="testimonial-dots">
          {testimonials.map((testimonial, index) => (
            <button
              key={testimonial.id}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
